import { ApplicationAccessType } from '@frontegg/rest-api';
export const getFlattenAppIds = listWithAppIds => {
  var _listWithAppIds$map$r;
  return (_listWithAppIds$map$r = listWithAppIds.map(({
    appIds
  }) => appIds).reduce((allAppIds, currentAppIds) => {
    currentAppIds == null ? void 0 : currentAppIds.forEach(item => {
      if (allAppIds && !allAppIds.includes(item)) {
        allAppIds.push(item);
      }
    });
    return allAppIds;
  }, [])) != null ? _listWithAppIds$map$r : [];
};
export const combineUserApplicationsWithTenantFreeAccess = (userApplications, accountApplications) => {
  if (!userApplications && !accountApplications) return [];
  const userAppIds = new Set((userApplications == null ? void 0 : userApplications.map(app => app.id)) || []);
  const tenantFreeApps = (accountApplications == null ? void 0 : accountApplications.filter(app => app.tenantApplicationAccessType === ApplicationAccessType.FREE_ACCESS)) || [];

  // Add tenant-free apps that aren't already in user apps
  const additionalApps = tenantFreeApps.filter(app => !userAppIds.has(app.id));

  // Create a combined list
  const combinedApps = [...(userApplications || []), ...additionalApps];
  return combinedApps;
};